import React from 'react';
import { Dispatch } from '@reduxjs/toolkit';

import { Document } from '../../../../interfaces/document/document.interface';

import { RemoveDocumentAction } from '../../../../actions/document/document.types';
import { DocumentActions } from '../../../../actions/document/document.actions';

import { useAppDispatch, useRemoval } from '../../../../hooks';

import { Modal } from '../../../../components/modal/Modal';
import { ModalLayout } from '../../../../components/modal/ModalLayout';
import RemoveModal from '../../../../components/modal/remove/RemoveModal';

const RemoveDocumentContainer = () => {
  const dispatch: Dispatch<RemoveDocumentAction> = useAppDispatch();

  const { element, showModal, setShowModal } = useRemoval();

  const onClose = () => setShowModal(false);

  const handleConfirm = (onComplete: () => void) => {
    dispatch(
      DocumentActions.removeDocument((element as Document).id as number, () => {
        onComplete();
        onClose();
      })
    );
  };

  return (
    <>
      {showModal && (
        <Modal>
          <ModalLayout onClose={onClose} title="Remove Company Document">
            <RemoveModal title={(element as Document).name} onConfirm={handleConfirm} />
          </ModalLayout>
        </Modal>
      )}
    </>
  );
};

export default RemoveDocumentContainer;
